<template>
  <div>
    <van-pull-refresh v-model="isLoading"
                      @refresh="onRefresh">
      <van-list v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad">
        <van-collapse v-model="activeNames"
                      border
                      accordion
                      v-if="itemList.length > 0">
          <van-collapse-item v-for='(item, index) in itemList'
                             :key='item.LectureCommentClassTableID'
                             :title="item.DisciplineName"
                             border
                             :name="index"
                             :value="item.TeacherName">
            <div class="display-flex flex-ju-space-be box-item">
              <p>课程：</p>
              <p v-text="item.DisciplineName"></p>
            </div>
            <div class="display-flex flex-ju-space-be box-item">
              <p>教室：</p>
              <p v-text="item.HouseName"></p>
            </div>
            <div class="display-flex flex-ju-space-be box-item">
              <p>开始时间：</p>
              <p v-text="item.StartTime"></p>
            </div>
            <div class="display-flex flex-ju-space-be box-item">
              <p>结束时间：</p>
              <p v-text="item.EndTime"></p>
            </div>
            <div class="display-flex flex-ju-space-be box-item">
              <p>主讲教师：</p>
              <p v-text="item.TeacherName"></p>
            </div>
            <div class="display-flex flex-ju-space-be box-item">
              <p>备注：</p>
              <p v-text="item.Remarks"></p>
            </div>
            <div class="display-flex flex-ju-space-be box-item">
              <p>听讲人：</p>
              <p v-text="item.EvaluateTeachersName"></p>
            </div>

          </van-collapse-item>
        </van-collapse>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { setTimeout } from "timers";
import '@/assets/styles/flexCss/Index.less'
export default {
  name: 'Listening',
  props: {
    dataList: {
      type: Array
    },
    totalRecords: {
      type: Number
    },
    num: {
      type: Number
    },
    status: {
      type: Number
    },
    resSt: {
      type: Boolean
    }
  },
  data () {
    return {
      activeNames: 0,
      itemList: [],
      loading: false,
      finished: false,
      isLoading: false,
    }
  },
  created () {
  },
  methods: {
    onRefresh () {
      if (this.itemList >= this.totalRecords) return;
      setTimeout(() => {
        // this.itemList = []
        this.status ? this.$emit('getCom', 1) : this.$emit('getList', 1)
        this.isLoading = false;
      }, 500);
    },
    onLoad () {
      // 异步更新数据
      setTimeout(() => {
        this.status ? this.$emit('getCom', this.num + 1) : this.$emit('getList', this.num + 1)
      }, 500);
    },
  },
  watch: {
    dataList: {
      handler (val) {
        // 加载状态结束
        this.loading = false;
        this.itemList = val
        // 数据全部加载完成
        this.finished = val.length >= this.totalRecords ? true : false
      },
      deep: true,
    },
  },
}
</script>
<style lang='less' scope>
.box-item {
  background-color: #fff;
  min-height: 70px;
  flex-flow: row wrap;
  p {
    align-self: center;
    min-width: 130px;
    line-height: 1.8;
  }
}
</style>